import * as React from "react";
import Slider from "react-slick";
import moment from "moment";
import { PropertyDetails } from "../../../core/api/models/project";
import { convertPascalCaseToWords } from "../../../core";

interface IFinanceInformationProps {
  templates: any;
  index: number;
  propertyDetails?: PropertyDetails[];
  onRemove: (propertys: PropertyDetails[]) => void;
  onSelect: () => void;
}

const LocationSort: React.FunctionComponent<IFinanceInformationProps> = (
  props
) => {
  const renderDetails = () => {
    return (
      <>
        <div className="border px-3 py-2 mb-2">
          <i
            className="icon-arrange text-gray-400 cursor-pointer"
            style={{ fontSize: "8px" }}
          ></i>
          <span className="font-sm ml-3 font-weight-semibold py-1 d-inline-block">
            {props.templates} (
            {
              props.propertyDetails?.filter(
                (x) => x.cityLocName === props.templates
              )?.length
            }
            )
          </span>
        </div>
      </>
    );
  };

  return <>{renderDetails()}</>;
};

export default LocationSort;
